import { Injectable } from '@angular/core';
import { Headers, RequestOptions, URLSearchParams, Http } from '@angular/http';

import 'rxjs/add/operator/toPromise';

import { DoctorModel } from '../model/index';

@Injectable()
export class DoctorService {
    private headers = new Headers({
       'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
    });
    private doctorUrl = 'api/doctor';

    constructor(private http: Http) { }

    private extractData(res: any) {
        let body = res.json();
        return body || [];
    }

    getDoctorList(query: any): Promise<DoctorModel[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.doctorUrl}/doctorList`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

    getDoctor(ref_id: number): Promise<DoctorModel> {
        const url = `${this.doctorUrl}/doctorList?ref_id=${ref_id}`;
        return this.http.get(url)
            .toPromise()
            .then(response => response.json().data as DoctorModel)
            .catch(this.handleError);
    }

    deleteDoctor(doctor_id: any): Promise<DoctorModel> {
        const url = `${this.doctorUrl}/deleteDoctor`;
        return this.http
            .post(url, $.param({ doctor_id: doctor_id }), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as DoctorModel)
            .catch(this.handleError);
    }

    addEditUpdateDoctor(doctorData: any): Promise<DoctorModel> {
        const url = `${this.doctorUrl}/addEditUpdateDoctor`;

        return this.http
            .post(url, $.param(doctorData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as DoctorModel)
            .catch(this.handleError);
    }

    private handleError(error: any): Promise<any> {
        console.error('An error occurred', error);
        return Promise.reject(error.message || error);
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/services/doctor.service.ts